// src/components/Layout.js
import React from "react";
import Topbar from "./Topbar";
import Navbar from "./Navbar";
import Footer from "./Footer";
import CopyRight from "./CopyRight";
// import Footer from "./Footer"; // agar footer ho

const Layout = ({ children }) => {
  return (
    <>
      {/* <Topbar /> */}
      <Navbar />
      {children}
      <Footer />
      <CopyRight />
    </>
  );
};

export default Layout;
